import React from 'react';

export const Bookmark = ({}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 4C5.44772 4 5 4.44772 5 5V19.0988C5 19.904 5.90309 20.379 6.56658 19.9228L11.4334 16.5764C11.7747 16.3417 12.2253 16.3417 12.5666 16.5764L17.4334 19.9228C18.0969 20.379 19 19.904 19 19.0988V5C19 4.44772 18.5523 4 18 4H6Z" fill="white"/>
        </svg>
    )
};
